export const SidebarIdGlobalAppsSettings = 'GLOBAL_APPS_SETTINGS' as const;
